// extracted by mini-css-extract-plugin
export default {"main":"colors_main__lBeJL","colors":"colors_colors__tZGVT","color":"colors_color__oxQrU"};